import React from "react";

export default function ML_Training() {
  return (
    <div>
      <h1>ML_Training</h1>
      <p>This is the ML_Training component.</p>
    </div>
  );
}
